import { Leaf } from "lucide-react";
import { NPN, OWNER_EMAIL } from "@/components/store/data";

export default function Footer({ onNav }) {
  return (
    <footer className="border-t border-white/10 bg-[#08302D]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 text-[#F4F1EB] mb-4">
              <Leaf className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
              <span className="font-display text-lg">Ubiquinol CoQ10</span>
            </div>
            <p className="text-sm text-[#B8C5C4] leading-relaxed max-w-xs">
              Premium bio-active Coenzyme Q10 for energy, heart health and cellular longevity.
            </p>
          </div>

          <div className="text-sm text-[#B8C5C4] space-y-2">
            <p className="uppercase tracking-[0.2em] text-xs text-[#D4AF37] mb-3">Product</p>
            <p>Natural Product Number: {NPN}</p>
            <p>$38 CAD / bottle · $8 CAD standard shipping</p>
            <button onClick={() => onNav("checkout")} className="underline underline-offset-4 hover:text-[#F4F1EB]">Order now</button>
          </div>

          <div className="text-sm text-[#B8C5C4] space-y-2">
            <p className="uppercase tracking-[0.2em] text-xs text-[#D4AF37] mb-3">Payment</p>
            <p>Secured via PayPal</p>
            <p>Receipts sent to {OWNER_EMAIL}</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p data-testid="product-disclaimer" className="text-xs text-[#B8C5C4]/70 max-w-lg">
            Disclaimer: Actual product bottle may look different than shown. These statements have not been evaluated to diagnose, treat or cure any disease.
          </p>
          <p className="text-xs text-[#B8C5C4]/60">© {new Date().getFullYear()} Ubiquinol CoQ10. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
